import { Plus } from "lucide-react";
import { Eyebrow, Reveal } from "./Motion";

export const FAQ = ({ title = "Frequently asked questions", items, testId = "faq-section" }) => {
  const schema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: items.map((f) => ({ "@type": "Question", name: f.q, acceptedAnswer: { "@type": "Answer", text: f.a } })),
  };
  return (
    <section data-testid={testId} className="px-5 py-20 sm:px-8 sm:py-28 lg:px-12">
      <div className="mx-auto grid max-w-[1400px] gap-12 lg:grid-cols-12">
        <Reveal className="lg:col-span-4">
          <Eyebrow>FAQ</Eyebrow>
          <h2 className="font-display mt-5 text-4xl leading-[1.05] text-white sm:text-5xl">{title}</h2>
        </Reveal>
        <div className="lg:col-span-7 lg:col-start-6">
          {items.map((f, i) => (
            <details key={f.q} data-testid={`${testId}-item-${i}`} className="group border-b border-[#D4AF37]/15 py-6 [&_summary::-webkit-details-marker]:hidden">
              <summary className="flex cursor-pointer list-none items-start justify-between gap-6">
                <h3 className="font-display text-2xl leading-snug text-white">{f.q}</h3>
                <Plus className="mt-1.5 h-5 w-5 shrink-0 text-[#D4AF37] transition-transform duration-300 group-open:rotate-45" />
              </summary>
              <p className="mt-4 max-w-2xl text-[15px] leading-relaxed text-slate-300">{f.a}</p>
            </details>
          ))}
        </div>
      </div>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }} />
    </section>
  );
};

export const ProseSection = ({ eyebrow, title, paragraphs, testId }) => (
  <section data-testid={testId} className="px-5 py-20 sm:px-8 sm:py-24 lg:px-12">
    <div className="mx-auto grid max-w-[1400px] gap-10 lg:grid-cols-12">
      <Reveal className="lg:col-span-4">
        <Eyebrow>{eyebrow}</Eyebrow>
        <h2 className="font-display mt-5 text-4xl leading-[1.05] text-white sm:text-5xl">{title}</h2>
      </Reveal>
      <Reveal delay={0.1} className="space-y-5 text-base leading-relaxed text-slate-300 sm:text-lg lg:col-span-7 lg:col-start-6">
        {paragraphs.map((p) => <p key={p.slice(0, 24)}>{p}</p>)}
      </Reveal>
    </div>
  </section>
);
